/* eslint-disable no-underscore-dangle */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Router from 'next/router';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';

import { withTranslation } from 'language/i18n';
import { getObjectByLanguage } from 'language/helpers';
import { addToWatchList, getWatchlist, deleteFromWatchList } from 'models/user';
import { UserContext } from 'contexts/userContext';
import { StatusContext } from 'contexts/statusContext';
import { Button } from 'components/common';
import { MACHINE_STATE } from 'constants/common';

const ProductDetail = ({ t, machine }) => {
  const { userData, isLoggedIn } = useContext(UserContext);
  const user = userData;
  const { setErrorState } = useContext(StatusContext);

  const [isAddedWatchlistBefore, setIsAddedWatchlistBefore] = useState(false);
  const [onResponse, setOnResponse] = useState(false);

  useEffect(() => {
    checkWatchlist();
  }, [isLoggedIn]);

  const checkWatchlist = async () => {
    if (isLoggedIn) {
      const watchlistFromApi = await getWatchlist(user.id);
      const foundWatchlist = find(watchlistFromApi, ['id', machine.id]);
      if (foundWatchlist) {
        setIsAddedWatchlistBefore(true);
      }
    }
  };

  const addToWatchlist = async () => {
    try {
      if (isLoggedIn) {
        setOnResponse(true);
        await addToWatchList(user.id, machine.id);
        setIsAddedWatchlistBefore(true);
      } else {
        setErrorState({
          title: t('alert'),
          text: 'İzleme listesine ekleme yapabilmeniz için giriş yapmanız gerekmektedir.',
          buttonText: t('login'),
          onClickButton: () => {
            setErrorState({});
            Router.push({
              pathname: '/login',
              query: {
                redirectTo: Router.asPath,
              },
            });
          },
        });
      }
    } catch (error) {
      console.log('addToWatchlistErr', error);
    } finally {
      setOnResponse(false);
    }
  };

  const deleteMachineFromWatchList = async () => {
    try {
      setOnResponse(true);
      await deleteFromWatchList(user.id, machine.id);
      setIsAddedWatchlistBefore(false);
    } catch (error) {
      console.log('deleteMachineFromWatchListErr', error);
    } finally {
      setOnResponse(false);
    }
  };

  return (
    <>
      <div className="row mb-4">
        <div className="col">
          <h2 className="fs-13 fw-900">{t('productDetails')}</h2>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col">
          <ul className="im-list im-list--type5">
            <li>
              <div className="im-list__label">{t('brand')}</div>
              <div className="im-list__value">{`${machine.brand}`}</div>
            </li>
            <li>
              <div className="im-list__label">{t('model')}</div>
              <div className="im-list__value">{`${machine.model}`}</div>
            </li>
            <li>
              <div className="im-list__label">{t('machineProductYear')}</div>
              <div className="im-list__value">{`${machine.manufactureYear}`}</div>
            </li>
            <li>
              <div className="im-list__label">{t('workingHours')}</div>
              <div className="im-list__value">{`${machine.workingHours} ${t('hour')}`}</div>
            </li>
            <li>
              <div className="im-list__label">{t('machineCondition')}</div>
              <div className="im-list__value">{`${machine.condition}`}</div>
            </li>
            <li>
              <div className="im-list__label">{t('serialNumber')}</div>
              <div className="im-list__value">{machine.serialNumber}</div>
            </li>
            <li>
              <div className="im-list__label">{t('address')}</div>
              <div className="im-list__value">{`${machine.region}/${machine.district}`}</div>
            </li>
          </ul>
          {
            !isEmpty(machine.summary) && (
              <p className="fs-13 mt-4 mb-0">{getObjectByLanguage(machine.summary)}</p>
            )
          }
        </div>
      </div>
      <div className="row">
        {
          (![MACHINE_STATE.SOLD, MACHINE_STATE.SUSPENDED, MACHINE_STATE.UNSOLD].includes(machine.state)) && (
            <div className="col mb-4">
              {
                isAddedWatchlistBefore
                  ? (
                    <Button
                      type="button"
                      className="im-button im-button--primary im-button--fluid im-button--center im-button--gutter-5 text-gray4"
                      loading={onResponse}
                      withoutFormItem
                      onClick={() => deleteMachineFromWatchList()}
                    >
                      <div className="im-button__icon im-button__icon--left">
                        <i className="fa-solid fa-minus fs-14" />
                      </div>
                      <span className="fs-13">{t('removeFromYourWatchList')}</span>
                    </Button>
                  )
                  : (
                    <Button
                      type="button"
                      className="im-button im-button--outline-yellow2 im-button--fluid im-button--center im-button--gutter-5 text-gray4"
                      loading={onResponse}
                      withoutFormItem
                      onClick={() => addToWatchlist()}
                    >
                      <div className="im-button__icon im-button__icon--left">
                        <i className="fa-solid fa-plus fs-14" />
                      </div>
                      <span className="fs-13">{t('addToYourWatchList')}</span>
                    </Button>
                  )
              }
            </div>
          )
        }
        {/* <div className="col mb-4">
          <a
            className="im-button im-button--transparent im-button--fluid im-button--center im-button--gutter-5 text-gray4"
          >
            <div className="im-button__icon im-button__icon--left">
              <i className="fal fa-comments-alt fs-14" />
            </div>
            <span className="fs-13">{t('questionToTheSeller')}</span>
          </a>
        </div> */}
      </div>
    </>
  );
};

ProductDetail.propTypes = {
  t: PropTypes.func,
  machine: PropTypes.object,
};

export default withTranslation('common')(ProductDetail);
